import { create } from '@bufbuild/protobuf'
import type { ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { getTradingPartnerContact } from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'
import {
  GetTradingPartnerContactRequestSchema,
  type GetTradingPartnerContactResponse,
} from '@ebalance/proto/bffuser/v1/occto_master_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * 連絡先モーダルの取得 hook (plan-common.md §連絡先モーダル AC-CM-001)。
 *
 * モーダルを開いた時だけ mount されるので、電話アイコンのクリックまで RPC は
 * 飛ばない。同じ取引先を開き直した時は React Query の cache を使う。
 * found=false (取引先マスタ未登録) は正常応答で、呼び出し側が空状態を描画する。
 */
export function useGetTradingPartnerContact(
  counterpartyCode: string,
): UseQueryResult<GetTradingPartnerContactResponse, ConnectError> {
  return useQuery(
    getTradingPartnerContact,
    create(GetTradingPartnerContactRequestSchema, { counterpartyCode }),
  )
}
